import App from './App.svelte';

const domTarget = document.getElementById("tesauro-tree");

const app = domTarget && new App({
	target: domTarget,
	props: {}
});

export default app;